export default "__VITE_ASSET__qutoW$Cp__"